import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Snackbar from "@mui/material/Snackbar";

const BetTrackerButton = ({ content }) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const copyDataToClipboard = () => {
    navigator.clipboard.writeText(content).then(
      () => {
        setOpenSnackbar(true);
      },
      (err) => {
        console.error("Failed to copy: ", err);
      }
    );
  };

  return (
    <>
      <IconButton
        sx={{ color: "white" }}
        onClick={copyDataToClipboard}
        aria-label="copy to clipboard"
      >
        <ContentCopyIcon />
      </IconButton>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={() => setOpenSnackbar(false)}
        message="Copied to clipboard"
      />
    </>
  );
};

export default BetTrackerButton;
